import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=6fa8d1da&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"
import style0 from "./classify.vue?vue&type=style&index=0&id=6fa8d1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8d1da",
  null
  
)

export default component.exports